<div class="container">
    <div class="header">
        <ng-container *ngIf="isImport">{{ 'sensor-cable-tag.dialog-title.import' | translate }}</ng-container>
        <ng-container *ngIf="!isImport"> {{ 'sensor-cable-tag.dialog-title.export' | translate }} </ng-container>
    </div>
    <div class="fieldset">
        <div class="input-container" (click)="openList()" #listInput>
            <input type="text" class="name input" readonly [ngModel]="displayedFcu" />
            <mat-icon svgIcon="arrow-down" class="icon" [ngStyle]="{ transform: showList ? 'rotate(180deg)' : '' }" />
        </div>

        <ng-container *ngIf="showList && fcuOptions?.length > 0">
            <div class="list-container" #listContainer>
                <div
                    *ngFor="let fcuNum of fcuOptions"
                    (click)="$event.stopPropagation(); handleFcuSelected(fcuNum)"
                    [ngClass]="{ highlighted: selectedFcu === fcuNum }"
                    class="list-item">
                    <div>
                        {{ 'dlg.FCU' | translate: { num: fcuNum } }}
                    </div>

                    <ng-container *ngIf="selectedFcu == fcuNum">
                        <mat-icon class="check-icon" svgIcon="check" />
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="button-container">
        <div class="button simple" (click)="close()">
            {{ 'dlg.cancel' | translate }}
        </div>
        <div class="button" (click)="selectVersion()">
            <ng-container *ngIf="isImport">{{ 'dlg.import' | translate }}</ng-container>
            <ng-container *ngIf="!isImport"> {{ 'dlg.download' | translate }} </ng-container>
        </div>
    </div>
</div>
